import React, { useEffect, useRef, useState } from "react";
import { useMemberstack } from "@memberstack/react";
import { API_BASE } from "../../config";
import { CheckCircleIcon } from "@heroicons/react/24/outline";
import { Link, useSearchParams } from "react-router-dom";

function OnboardEnd() {
  const memberstack = useMemberstack();
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;

    const sessionId = searchParams.get("session_id");

    console.log("session id",sessionId)

    const run = async () => {
      try {
        if (!sessionId) {
          throw new Error("Session Stripe manquante.");
        }

        //https://cloterenotaire.onrender.com/api/end-abonnement?session_id
        //http://localhost:5050/api/end-abonnement?session_id
        const response = await fetch(
          `${API_BASE}/api/end-abonnement?session_id=${encodeURIComponent(
            sessionId
          )}`
        );
        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.error || "Impossible de finaliser l’abonnement.");
        }

        localStorage.setItem('clotere_show_welcome', '1');
        await memberstack.logout();
      } catch (e) {
        console.error(e);
        setError(e.message || "Une erreur est survenue.");
      } finally {
        setLoading(false);
      }
    };

    run();
  }, [memberstack, searchParams]);

  return (
    <main className="grid min-h-[100vh] place-items-center bg-gradient-to-b from-indigo-100 to-pink-100 px-6 py-24 sm:py-24 lg:px-8">
      <div className="text-center max-w-3xl">
        <h1 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">
          Bienvenue chez Clotere 🥳
        </h1>

        {loading ? (
          <p className="mt-6 text-lg leading-8 text-gray-600">
            Validation de votre abonnement en cours…
          </p>
        ) : error ? (
          <p className="mt-6 text-lg leading-8 text-red-600">{error}</p>
        ) : (
          <p className="mt-6 text-lg leading-8 text-gray-600">
            Votre compte a bien été créé. Vous pouvez maintenant vous connecter.
          </p>
        )}
      </div>

      {!loading && !error && (
        <div className="flex items-center justify-center gap-x-6">
          <ul className="-mt-6 border-b border-gray-900/5 flex flex-wrap justify-center gap-4">
            {[
              "Vérification de vos informations",
              "Création de votre environnement notaire sécurisé",
              "Ouverture du compte",
            ].map((item) => (
              <li
                key={item}
                className="relative flex gap-x-6 p-6 bg-white rounded-lg items-center w-full sm:w-auto"
              >
                <div className="flex h-10 w-10 flex-none items-center justify-center rounded-lg shadow-sm ring-1 ring-gray-900/10">
                  <CheckCircleIcon className="h-6 w-6 text-emerald-500" />
                </div>
                <div className="flex-auto">
                  <h3 className="text-sm font-semibold leading-6 text-gray-900">{item}</h3>
                </div>
              </li>
            ))}
          </ul>
        </div>
      )}

      {!loading && (
        <Link to="/app/connexion" className="btn-main mt-10">
          Me connecter
        </Link>
      )}

      <p className="mt-3 text-center text-sm text-gray-500">
        Vous avez une question ?<br /><br />
        L'équipe Clotere est joignable par mail à{" "}
        <a href="mailto:contact@clotere.fr" className="font-bold text-indigo-800">
          contact@clotere.fr
        </a>{" "}
        ou sur{" "}
        <a
          href="https://wa.me/0753585540"
          target="_blank"
          rel="noreferrer"
          className="font-bold text-indigo-800"
        >
          WhatsApp
        </a>{" "}
        au 07 53 58 55 40.
      </p>
    </main>
  );
}

export default OnboardEnd;